module.exports = __webpack_public_path__ + "img/set-goals.203be53.svg";